var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrapper px-3 pb-3 pt-2"},[_c('div',{staticClass:"table-scroll",style:({height: _vm.height, 'overflow': _vm.autoScroll && 'auto'})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }